<span class="dvb-gueltigkeit" ng-bind="vm.gueltigkeitText"></span>
